<div *ngFor="let youngAdultsSchool of schools" class="young-adults-data">
  <lx-price-lists-portal-young-adults-header
    [company]="company"
    [youngAdultsSchool]="youngAdultsSchool"
    [applicationForms]="applicationForms"
  ></lx-price-lists-portal-young-adults-header>
  <lx-price-lists-portal-camps-course-table
    [company]="company"
    [currency]="youngAdultsSchool?.youngAdultSchoolInfo?.currency"
    [packages]="youngAdultsSchool?.packages"
    [courseNotes]="youngAdultsSchool?.notes"
    [courseNotesSubject]="youngAdultsCoursesSubject"
  ></lx-price-lists-portal-camps-course-table>
  <lx-price-lists-portal-camp-dates
    [company]="company"
    [currency]="youngAdultsSchool?.youngAdultSchoolInfo?.currency"
    [endDatesFlag]="endDatesFlag"
    [juniorDatesNotes]="youngAdultsSchool?.notes"
    [startDates]="youngAdultsSchool?.startDates"
  ></lx-price-lists-portal-camp-dates>
  <lx-price-lists-portal-camps-transfers-table
    [company]="company"
    [currency]="youngAdultsSchool?.youngAdultSchoolInfo?.currency"
    [transferNotes]="youngAdultsSchool?.notes"
    [transfers]="youngAdultsSchool?.transfers"
    [transferNotesSubject]="youngAdultsTransfersSubject"
  ></lx-price-lists-portal-camps-transfers-table>
  <lx-price-lists-portal-young-adults-private-lessons-table
    [company]="company"
    [currency]="youngAdultsSchool?.youngAdultSchoolInfo?.currency"
    [privateLessons]="youngAdultsSchool?.privateLessons"
    [privateLessonsNotes]="youngAdultsSchool?.notes"
  ></lx-price-lists-portal-young-adults-private-lessons-table>
  <lx-price-lists-portal-general-fee-table
    [company]="company"
    [currency]="youngAdultsSchool?.youngAdultSchoolInfo?.currency"
    [generalFeesNotes]="youngAdultsSchool?.notes"
    [generalFees]="youngAdultsSchool?.fees"
  ></lx-price-lists-portal-general-fee-table>
</div>
